import React, {
  Suspense,
} from 'react';
import {
  Redirect,
  Router,
  Switch
} from 'react-router-dom';
import { createHashHistory } from 'history';
import {
  ELSIdleProvider,
  ELSPageLoader,
  ELSAccessibilityFocusState,
} from '@els/els-ui-common-react';
import { ELSModalProvider } from '@els/els-component-modal-react';
import {
  IntlProvider,
} from 'react-intl';
import {
  setDefaultAppConfig
} from './app.config';
import ErrorBoundary from '../error-boundary/ErrorBoundary.component';
import LocationChangeHandler from '../location-change-handler/LocationChangeHandler.component';
import {
  getAppRoutes
} from './app.routes';
import {
  AppConstants,
  RoutePath
} from './app.constants';
import '../../assets/main.scss';
import {
  getLanguage,
  messages
} from '../../utilities/app.utilities';
import AppProvider from './AppProvider.component';
import withHTMLHeadSEO from '../../hocs/with-html-head-seo/withHTMLHeadSEO.hoc';
import AnalyticsRegistrar from '../analytics-registrar/AnalyticsRegistrar.component';
import MessagesRegistrar from '../messages-registrar/MessagesRegistrar.component';
import AppRegistrar from './AppRegistrar.component';
import MaintenanceHandler from '../maintenance-handler/MaintenanceHandler.component';
import LaunchingRecommendationLoader from '../launching-recommendation-loader/LaunchingRecommendationLoader.component';
import { createRoute } from './app-route.utilities';

import { RecordEmpty } from '../../models/common.models';

setDefaultAppConfig();

const history = createHashHistory<RecordEmpty>();
const HTMLHeadSEOComponent = withHTMLHeadSEO(null)(null);
const App = (): JSX.Element => {
  return (
    <AppProvider>
      <IntlProvider locale={getLanguage()} messages={messages[getLanguage()]}>
        <ErrorBoundary>
          <Router history={history}>
            <ELSModalProvider>
              <>
                <AppRegistrar />
                <HTMLHeadSEOComponent />
                <AnalyticsRegistrar />
                <MessagesRegistrar />
                <LocationChangeHandler />
                <MaintenanceHandler />
                <LaunchingRecommendationLoader />
                <Suspense fallback={<ELSPageLoader />}>
                  <Switch>
                    {
                        getAppRoutes()
                          .map((route) => {
                            return createRoute(route);
                          })
                      }
                    <Redirect from="/" exact to={RoutePath.NOT_AUTHORIZED} />
                    <Redirect to={RoutePath.PAGE_NOT_FOUND} />
                  </Switch>
                </Suspense>
              </>
            </ELSModalProvider>
          </Router>
          <ELSAccessibilityFocusState />
          <ELSIdleProvider
            timeout={AppConstants.IDLE_TIMEOUT}
            onSessionTimeout={() => {
              history.push(RoutePath.TIMEOUT);
            }}
          />
        </ErrorBoundary>
      </IntlProvider>
    </AppProvider>
  );
};

export default App;
